function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMccCommuter = function SvgMccCommuter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 7.383C6 5.661 7.104 4.141 8.783 3.76A51.528 51.528 0 0 1 20 2.5c4.7 0 8.708.69 11.217 1.26C32.896 4.14 34 5.66 34 7.383V27.5a3 3 0 0 1-3 3h-1.034l1.862 4.188a2 2 0 1 1-3.656 1.624L25.59 30.5H14.411l-2.583 5.812a2 2 0 1 1-3.656-1.624l1.862-4.188H9a3 3 0 0 1-3-3V7.383ZM29 18.5h-7.5V6.52c3.352.083 5.712.435 7.081.708.853.17 1.419.93 1.419 1.8V17.5a1 1 0 0 1-1 1ZM11.419 7.227c1.369-.273 3.73-.625 7.081-.708V18.5H11a1 1 0 0 1-1-1V9.027c0-.87.566-1.63 1.419-1.8ZM11 26.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm20-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z",
    clipRule: "evenodd",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgMccCommuter;